import moment from "moment";
import { getSupplierName } from "../../flight/supplier/getSupplierName";
import { getSupplierClass } from "../../../components/flight/FlightOfferDisplay";
import { flightStatusMap } from "../../../pages/Orders/OrdersData";
import { formatPackagePrice } from "../../../utils/esimFormat";

export function templateEsimOrderData(data) {
  const esimData = data || {};
  const packageDetails =
    esimData.packageDetails || esimData.package_details || {};
  const country =
    packageDetails.country ||
    packageDetails.country_title ||
    packageDetails.countryTitle ||
    {};
  const countryTitle =
    (typeof country === "string" ? country : country?.title) ||
    packageDetails.country_code ||
    packageDetails.countryCode ||
    "—";
  const packageTitle =
    packageDetails.title ||
    packageDetails.data ||
    esimData.packageId ||
    esimData.package_id ||
    "eSIM";
  const durationDays = packageDetails.day;
  const quantity = esimData.quantity || 1;

  const amountPrice = Number(
    packageDetails.amount ??
      packageDetails.packageAmount ??
      packageDetails.displayAmount ??
      esimData.amount,
  );
  const hasNgnAmount = Number.isFinite(amountPrice);
  const displayPrice = hasNgnAmount
    ? amountPrice
    : Number(
        esimData?.grandTotal ||
          esimData?.fareGrandTotal ||
          esimData?.unitPrice ||
          packageDetails?.price,
      );
  const currency = hasNgnAmount ? "NGN" : packageDetails?.currency || "USD";

  return [
    {
      elements: [
        {
          type: "title",
          value: moment(esimData?.createdAt)?.format("DD-MM-YYYY HH:mm [GMT]Z"),
        },
        {
          type: "copy",
          value: esimData?.bookingId || esimData?._id,
          renderValue: () => esimData?.bookingId || esimData?._id,
        },
        {
          type: "tag",
          value: getSupplierName(esimData?.supplier),
          className: getSupplierClass(esimData?.supplier),
          color: "text-[#BD002A]",
          background: "bg-[#BD002A]/20",
        },
      ],
      value: moment(esimData?.createdAt)?.format("YYYY-MM-DD HH:mm"),
      width: "md:w-[25%]",
    },
    {
      elements: [
        { type: "title", value: "Package" },
        {
          type: "text",
          value: packageTitle,
        },
      ],
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Country" },
        {
          type: "text",
          value: countryTitle,
        },
      ],
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Details" },
        {
          type: "text",
          value:
            [
              quantity > 1 ? `${quantity}x` : null,
              durationDays ? `${durationDays} days` : null,
              packageDetails.is_unlimited || packageDetails.data === "Unlimited"
                ? "Unlimited"
                : packageDetails.data,
            ]
              .filter(Boolean)
              .join(" · ") || "—",
        },
      ],
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Agent Price" },
        {
          type: "text",
          value: formatPackagePrice(displayPrice, currency),
        },
      ],
      value: displayPrice,
      width: "md:w-[15%]",
    },
    {
      elements: [
        { type: "title", value: "Status" },
        { type: "status", value: esimData?.status },
      ],
      value: (function () {
        return [
          "Not Paid",
          "Paid",
          "Expired",
          "Awaiting ticketing",
          "Ticket issued",
          "Denied",
          "Canceled",
          "Cancelation Requested",
          "Ticket Canceled",
        ]?.findIndex((val) => val === flightStatusMap(esimData?.status));
      })(),
      width: "md:w-[15%]",
    },
  ];
}
